import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../shared/utils/apiConfig';

// Fetch clinic profile data
export const fetchClinicProfile = createAsyncThunk(
    'clinicProfile/fetchClinicProfile',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiClient.get('/clinics/profile_data');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في جلب بيانات العيادة');
        }
    }
);

// Update clinic profile data
export const updateClinicProfile = createAsyncThunk(
    'clinicProfile/updateClinicProfile',
    async (profileData, { rejectWithValue }) => {
        try {
            const response = await apiClient.post('/clinics/update_profile_data', profileData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في تحديث بيانات العيادة');
        }
    }
);

const clinicProfileSlice = createSlice({
    name: 'clinicProfile',
    initialState: {
        profileData: null,
        loading: false,
        updating: false,
        error: null,
        success: null,
    },
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        clearSuccess: (state) => {
            state.success = null;
        },
        clearProfileData: (state) => {
            state.profileData = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch Clinic Profile
            .addCase(fetchClinicProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchClinicProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.profileData = action.payload.data || action.payload;
            })
            .addCase(fetchClinicProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Update Clinic Profile
            .addCase(updateClinicProfile.pending, (state) => {
                state.updating = true;
                state.error = null;
            })
            .addCase(updateClinicProfile.fulfilled, (state, action) => {
                state.updating = false;
                state.success = action.payload.message || 'تم تحديث بيانات العيادة بنجاح';
                state.profileData = action.payload.data || state.profileData;
            })
            .addCase(updateClinicProfile.rejected, (state, action) => {
                state.updating = false;
                state.error = action.payload;
            });
    },
});

export const { clearError, clearSuccess, clearProfileData } = clinicProfileSlice.actions;
export default clinicProfileSlice.reducer;
